module.exports = __webpack_public_path__ + "media/images/lb/861-e19ebf4f3c8bddb294734b258e4f8ea1.svg";